<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <div class="form-group form-row">
        <label :for="safeId()" class="col-sm-4 col-form-label">Manifest</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId()" v-model="selectedManifest" :options="manifests"
                         text-field="label" value-field="value">
          </b-form-select>
        </div>
      </div>

      <div v-if="manifest">
        <div class="form-group form-row">
          <label :for="safeId('nameAndId')" class="col-sm-4 col-form-label">Name (ID)</label>
          <div class="col-sm-8">
            <input type="text" readonly class="form-control-plaintext" :id="safeId('nameAndId')"
                   v-model="nameAndId">
          </div>
        </div>

        <div class="form-group form-row">
          <label :for="safeId('version')" class="col-sm-4 col-form-label">Version</label>
          <div class="col-sm-8">
            <input type="text" readonly class="form-control-plaintext" :id="safeId('version')"
                   v-model="manifest.version">
          </div>
        </div>

        <div class="form-group form-row">
          <label :for="safeId('description')" class="col-sm-4 col-form-label">Description</label>
          <div class="col-sm-8">
            <input type="text" readonly class="form-control-plaintext" :id="safeId('description')"
                   v-model="manifest.description">
          </div>
        </div>

        <div class="form-group form-row">
          <label :for="safeId('properties')" class="col-sm-4 col-form-label">Properties</label>
          <div class="col-sm-8">
            <div v-for="prop in properties" :key="prop._key">{{ prop.label }}: {{ prop.type }}</div>
          </div>
        </div>

        <div class="form-group form-row">
          <div class="col-sm-8 offset-sm-4">
            <button type="button" class="btn btn-primary" @click="create">Create</button>
          </div>
        </div>
      </div>
    </window-tab>
  </window>
</template>

<style scoped>

</style>

<script>
import { uuid } from '@/lib'
import { windowPropsMixin } from '@/mixins'
import AppService from '../api/AppService'
import Vue from 'vue'

const BASE_URL_TEMPLATES = 'https://static.webcg.helvetic.stream/templates/'

export default {
  name: 'template-library',
  mixins: [windowPropsMixin],
  data () {
    return {
      errorMessage: null,
      selectedManifest: null,
      manifests: [],
      manifest: null
    }
  },
  watch: {
    selectedManifest: function (newManifest) {
      this.fetchManifest(newManifest)
    },
    selectedAccount: function () {
      this.fetchManifests()
    }
  },
  computed: {
    selectedAccount () {
      return this.$store.getters.selectedAccount
    },
    templateLibraryPolicies () {
      return (this.selectedAccount &&
        this.selectedAccount.policies &&
        this.selectedAccount.policies.templateLibrary &&
        this.selectedAccount.policies.templateLibrary.allow) || []
    },
    nameAndId () {
      if (!this.manifest) return ''
      return this.manifest.name ? `${this.manifest.name} (${this.manifest.id})` : this.manifest.id
    },
    properties () {
      if (!this.manifest) return ''
      const properties = this.manifest.schema.properties
      return Object.keys(properties).map(key => {
        const result = properties[key]
        result._key = key
        return result
      })
    }
  },
  created () {
    this.appService = new AppService(this.$store, this.$keycloak)
  },
  mounted () {
    this.fetchManifests()
  },
  methods: {
    getAllowedRules () {
      if (this.templateLibraryPolicies && this.templateLibraryPolicies.length > 0) {
        return this.templateLibraryPolicies
          .filter(p => p.startsWith('library:'))
          .map(value => value.replace('library:', ''))
      }
      let roles = this.$keycloak && this.$keycloak.resourceAccess && this.$keycloak.resourceAccess['webcg-studio'] &&
        this.$keycloak.resourceAccess['webcg-studio'].roles
      roles = roles && roles.length > 0 ? roles : ((Vue.prototype.$env && Vue.prototype.$env.DEFAULT_ROLES) || [])
      if (typeof roles === 'string') {
        try {
          roles = JSON.parse(roles)
        } catch (e) {}
      }
      return roles.filter(p => p.startsWith('library:')).map(value => value.replace('library:', ''))
    },
    create () {
      const description = this.manifest.description
      const componentType = (description.match(/component=([a-z0-9-]+)/) || [])[1] || 'loopic-template'
      const overlayUrl = BASE_URL_TEMPLATES.replace('https://', '/') + this.selectedManifest.replace('manifest.ograf.json', 'resources/index.html')
      const properties = this.manifest.schema.properties
      const data = Object.keys(properties).reduce((result, key) => {
        result[key] = properties[key].default
        return result
      }, {})
      this.appService.openCreateTemplate({
        templateId: uuid(),
        name: this.manifest.name || this.manifest.id,
        componentType: componentType,
        overlayData: data,
        templateData: {
          data
        },
        templateOptions: {
          schema: this.manifest.schema
        },
        overlays: [overlayUrl]
      })
    },
    fetchManifests () {
      this.errorMessage = null
      const request = new XMLHttpRequest()
      request.open('GET', BASE_URL_TEMPLATES)
      request.onload = function (event) {
        if (!event.target) {
          this.errorMessage = 'Unknown error'
          return
        }

        if (event.target.status !== 200) {
          this.errorMessage = event.target.statusText
          return
        }
        const response = JSON.parse(event.target.response)
        const allowedRules = this.getAllowedRules()
        console.log('[template-library] Allowed rules', allowedRules)
        this.manifests = response.manifests.filter(p => {
          const parts = p.split('/').filter(p => p !== 'manifest.ograf.json')
          let rules = allowedRules.map(value => value.split(':'))
          for (let i = 0; i < parts.length; i++) {
            const part = parts[i]
            if (rules.filter(rule => rule[i] === '*').length > 0) {
              return true
            }
            rules = rules.filter(rule => rule[i] === part)
            if (rules.length === 0) {
              return false
            }
          }
          return rules.length > 0
        }).map(value => {
          let parts = value.split('/')
          parts.pop()
          return {
            label: parts.join(' / '),
            value: value
          }
        })
        console.log('[template-library] Allowed templates', this.manifests)
      }.bind(this)
      request.onerror = function (event) {
        console.error('Failed to fetch manifests:', event)
        this.errorMessage = JSON.stringify(event)
      }.bind(this)
      request.send()
    },
    fetchManifest (newManifest) {
      this.errorMessage = null
      const request = new XMLHttpRequest()
      request.open('GET', BASE_URL_TEMPLATES + newManifest)
      request.onload = function (event) {
        if (!event.target) {
          this.errorMessage = 'Unknown error'
          return
        }

        if (event.target.status !== 200) {
          this.errorMessage = event.target.statusText
          return
        }
        this.manifest = JSON.parse(event.target.response)
      }.bind(this)
      request.onerror = function (event) {
        console.error('Failed to fetch manifest:', event)
        this.errorMessage = JSON.stringify(event)
      }.bind(this)
      request.send()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/template-library.vue